/* unplugin-vue-components disabled */import script from "./commonItem.vue?vue&type=script&setup=true&lang=js"
export * from "./commonItem.vue?vue&type=script&setup=true&lang=js"

import "./commonItem.vue?vue&type=style&index=0&id=3930d3e4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3930d3e4"]])

export default __exports__